import { Button } from "@ariakit/react";
import { useEffect, useState } from "react";
import { mysteriousButton } from "./style.css.ts";

export function MysteriousRedButton() {
  const [count, setCount] = useState(0);

  const labelOptions = [
    "Do not press",
    "No",
    "You. Better. Not.",
    "Just...",
    "Stop...",
    "Pressing...",
    "The button!",
    "Oh well...",
  ];
  const label = labelOptions[count] ?? labelOptions[labelOptions.length - 1];

  useEffect(() => {
    const effects: string[] = [];

    if (count > 3) {
      effects.push("brightness(1.5)");
    }

    if (count > 4) {
      effects.push("grayscale(1)");
    }

    if (count > 5) {
      effects.push("invert(1)");
    }

    if (count > 6) {
      effects.push(`blur(${(count - 6) * 3}px)`);
    }

    if (effects.length > 0) {
      document.documentElement.style.filter = effects.join(" ");
    }
  }, [count]);

  return (
    <Button
      className={mysteriousButton}
      onClick={() => {
        setCount((c) => c + 1);
      }}
    >
      {label}
    </Button>
  );
}
